export default "__VITE_ASSET__CAS8Ih9___"